module.exports = __webpack_public_path__ + "media/images/webhooks/pre_transfer_and_post_call-39e0012b2385cff89cfb1407e4da4393.png";